export interface Spreadsheet {
  id: string;
  name: string;
  owner: string;
  lastOpened?: Date;
}

export interface Worksheet {
  id: string;
  name: string;
}

export interface UploadExcelDialogData {
  confirmAction?: (form: UploadExcelFormData) => void;
}

export interface ViewModel {
  userConnected: boolean;
  email: string;
  accountUrl: string;
  spreadsheets: readonly Readonly<Spreadsheet>[];
  worksheets: readonly Readonly<Worksheet>[];
  showLoadMore: boolean;
  spreadsheetName: string;
}

export interface SpreadsheetPage {
  spreadsheets: readonly Spreadsheet[];
  nextPage?: string;
}

export interface ConnectionInfo {
  userConnected: boolean;
  email: string;
}
export interface UploadExcelFormData {
  tab: Tab;
  searchText: string;
  spreadsheetId: string;
  worksheetId: string | number;
  url: string;
  name: string;
  description: string;
}

export interface SimpleReport {
  token: string;
  layout: string;
}

export const TABS = ['OneDrive', 'SharePoint', 'By URL'] as const;

export type Tab = (typeof TABS)[number];
